import './hound1/style';
import FormStructure from './hound1/form_structure';

export default FormStructure;